import clsx from 'clsx';

type RiskLevel = 'LOW' | 'MEDIUM' | 'HIGH';

const STYLES: Record<RiskLevel, string> = {
  LOW: 'bg-green-100 text-green-800 border-green-200',
  // Michael Wallace (2026-10-21): MODERATE and any <10% finding in orange, as in the reports.
  MEDIUM: 'bg-orange-100 text-orange-800 border-orange-200',
  HIGH: 'bg-red-100 text-red-800 border-red-200',
};

const LABELS: Record<RiskLevel, string> = {
  LOW: 'Low Risk',
  MEDIUM: 'Moderate Risk',
  HIGH: 'High Risk',
};

export default function RiskBadge({ level, className }: { level: RiskLevel; className?: string }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border',
        STYLES[level],
        className,
      )}
    >
      {LABELS[level]}
    </span>
  );
}
